import { isChannel } from "@website/utils/channel/helpers";
import { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import toString from "lodash-es/toString";
import Head from "next/head";
import { HotelDomesticHotelDataType } from "./index.types";

type MetaType = {
  seoData: CMSSeoContentData;
  hotelData: HotelDomesticHotelDataType;
};

export const Meta = ({ seoData, hotelData }: MetaType) => {
  const { title: hotelTitle, city_title: cityTitle } = hotelData || {};

  const pageTitle =
    seoData?.title ??
    `هتل ${hotelTitle} ${cityTitle}: رزرو با بهترین قیمت، مشاهده عکس و نظر کاربران`;

  const pageDescription =
    seoData?.description ??
    `رزرو هتل ${hotelTitle} ${cityTitle} بهمراه مشخصات، کمترین قیمت، عکس اتاق ها، نظر کاربران و تخفیف ویژه در اسنپ تریپ. هتل ${hotelTitle} ${cityTitle} معرفی امکانات اتاق ها و پشتیبانی 24 ساعته`;

  return (
    <Head>
      {isChannel(["snapp-ir"]) ? (
        <title>
          {`رزرو هتل ${toString(hotelTitle)} در ${toString(cityTitle)}- اسنپ`}
        </title>
      ) : (
        <title>{pageTitle}</title>
      )}
      <meta name="description" content={pageDescription} />
    </Head>
  );
};
